<template>
  <div>
    <li v-for="alert in Alerts" :key="alert.name">
      <input
          type="radio"
          :value="alert.name"
          class="switch"
          v-model="picked"
          @change="storeValueName(alert.name)"
      />
      <label for="s1"><b>{{ alert.name }}</b></label>
    </li>
  </div>
</template>

<script>
export default {
  props: [
     "Alerts",
  ],
  data() {
    return {
      picked: '',
    }
  },
  methods: {
    storeValueName(name){
      this.$emit("store-value-name", name)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
@import "../../sass/_mixins.scss";

@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  input[type="checkbox"],
  input[type="radio"] {
    --active: #275efe;
    --active-inner: #fff;
    --focus: .2rem rgba(39, 94, 254, 0.3);
    --border: #bbc1e1;
    --border-hover: #275efe;
    --background: #fff;
    --disabled: #f6f8ff;
    --disabled-inner: #e1e6f9;
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 2.1rem;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    cursor: pointer;
    border: .1rem solid var(--bc, var(--border));
    background: var(--b, var(--background));
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;

&:after {
   content: "";
   display: block;
   left: 0;
   top: 0;
   position: absolute;
   transition: transform var(--d-t, 0.3s) var(--d-t-e, ease),
   opacity var(--d-o, 0.2s);
 }

&:checked {
   --b: var(--active);
   --bc: var(--active);
   --d-o: 0.3s;
   --d-t: 0.6s;
   --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
 }

&:hover {
&:not(:checked) {
&:not(:disabled) {
   --bc: var(--border-hover);
 }
}
}

&:focus {
  box-shadow: 0 0 0 var(--focus);
}

& + label {
    font-size: 1rem;
    line-height: 2.1rem;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    margin-left: .4rem;
    color: $color-grey-dark-3;
  }
}

input[type="radio"] {
&.switch {
   width: 3.8rem;
   border-radius: 1.1rem;

&:after {
   left: .2rem;
   top: .2rem;
   border-radius: 50%;
   width: 1.5rem;
   height: 1.5rem;
   background: var(--ab, var(--border));
   transform: translateX(var(--x, 0));
 }
&:checked {
   --ab: var(--active-inner);
   --x: 1.7rem;
 }
&:disabled {
&:not(:checked) {
&:after {
   opacity: 0.6;
 }
}
}
}
}
}

li {
  display: inline-block;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
</style>